import { useTheme } from "@pax/ui";
import { useEffect, useRef, useState } from "react";
import { thumbnailOf } from "../lib/thumbnails";

/** A published basemap's globe, drawn once it scrolls into view, fading in over the tile. */
export function BasemapThumbnail({
  assetId,
  className = "",
}: {
  assetId: string;
  className?: string;
}) {
  const { theme } = useTheme();
  const box = useRef<HTMLSpanElement>(null);
  const [seen, setSeen] = useState(false);
  const [picture, setPicture] = useState<string | null>(null);

  useEffect(() => {
    const element = box.current;
    if (!element) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry?.isIntersecting) setSeen(true);
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!seen) return;
    let alive = true;
    thumbnailOf(assetId, theme === "dark")
      .then(url => {
        if (alive) setPicture(url);
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, [assetId, seen, theme]);

  return (
    <span ref={box} className={`absolute inset-0 bg-[#ece9e4] dark:bg-[#151517] ${className}`}>
      {picture && (
        <img
          src={picture}
          alt=""
          className="size-full animate-in object-cover fade-in duration-500"
        />
      )}
    </span>
  );
}
